import api from '../../helpers/axios'

export const state = {
    user: null,
    users: []
};

export const getters = {
    user: (state) => state.user,
    users: (state) => state.users
};

export const mutations = {
    setUser(state, newValue) {
        state.user = newValue;
    },
    setUsers(state, newValue) {
        state.users = newValue;
    },
};


export const actions = {


        createLmsUser(_, data) {
            return new Promise((resolve, reject) => {
                api.post("/customer-users", data).then((res) => {
                    resolve(res.data.data);
                })
                    .catch((err) => {
                        reject(err)
                    })
            });
        },




    resetPassword(_, userId,) {
        return new Promise((resolve, reject) => {
        api.post(process.env.VUE_APP_LMS_API_URL + '/auth/reset-password', userId, {
             /*   headers: {
                    "domain": data.site
                }*/
            }).then(() => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });}

};


